export default {
  "monthlyClosing.th.theaterName": "劇場名",
  "monthlyClosing.th.month": "対象月",
  "monthlyClosing.th.accountName": "実施アカウント名",
  "monthlyClosing.th.closingTime": "締め処理時間",
  "monthlyClosing.th.status": "ステータス",

  "monthlyClosing.monthlyClosing": "月次締め",
  "monthlyClosing.deleted": "削除済",

  /** create record dialog */
  "monthlyClosing.dialog.title": "月次締め　登録/編集",
  "monthlyClosing.dialog.theaterName": "劇場名",
  "monthlyClosing.dialog.month": "対象月",
  "monthlyClosing.dialog.save": "保存",
  "monthlyClosing.dialog.placeholder": "選択してください"
};